import React, { Component } from "react";
import { connect } from "react-redux";

import styles from "../../commonModules/Helper.module.css";

import TicketRow from "./TicketRow";
import "react-virtualized/styles.css";

class TicketsList extends Component {
  renderRow(id, ticket, columns) {
    return <TicketRow id={id} ticket={ticket} columns={columns} />;
  }

  render() {
    let { columns, tickets, newTicketsIDs } = this.props;

    let classes = "table table-hover";

    if (this.props.userStore.querying_store) {
      classes += " " + styles.component_loader;
    }

    return (
      <table className={classes}>
        <tbody>
          {columns && columns.length < 1 && (
            <tr>
              <td>
                No tickets currently available, try using the sync button above.
              </td>
            </tr>
          )}
          <tr>
            <th>#</th>
            {columns.map((c, i) => {
              return <th key={i}>{c.displayName}</th>;
            })}
          </tr>

          {tickets.map((ticket, i) => {
            const rowId =
              // current index in array
              i +
              1 +
              // add current page * page_limit to calculate current id relative to page
              (this.props.page > 1 ? (this.props.page - 1) * 50 : 0);
            return this.renderRow(rowId, ticket, columns);
          })}
        </tbody>
      </table>
    );
  }
}

function mapStateToProps(store) {
  return {
    userStore: store.user,
    page: store.tickets.page
  };
}

export default connect(mapStateToProps)(TicketsList);
